import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import TextField from '@mui/material/TextField';
import { useCallback } from 'react';
import { FormControlContainer } from '../../../components/formControlContainer';
import { setCreateGameName } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
export const RoomNameControl = () => {
    const dispatch = useAppDispatch();
    const roomName = useAppSelector((state) => state.createGame.roomName);
    const onChangeRoomName = useCallback((event) => {
        dispatch(setCreateGameName(event.target.value));
    }, [dispatch]);
    return (_jsx(FormControlContainer, { isFlex: true, children: _jsx(TextField, { "data-testid": 'create-game-name', label: 'Room Name', onChange: onChangeRoomName, value: roomName, variant: 'outlined', fullWidth: true }) }));
};
